import React from "react";

const UnRetireIcon = ({ size = 16, className }) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6 14.667h4c3.334 0 4.667-1.333 4.667-4.667V6c0-3.333-1.333-4.666-4.666-4.666H6C2.667 1.334 1.334 2.667 1.334 6v4c0 3.334 1.333 4.667 4.667 4.667"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M5.413 5.666v3.28a2.054 2.054 0 0 0 4.107 0V4.433"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m8.486 5.38 1.053-1.046 1.047 1.046"
        />
      </svg>
    </span>
  );
};

export default UnRetireIcon;
